"use strict";
class PageController {
    constructor($scope, SSHttpService, SSUtilService, SSAppService, $sce) {

        const self = this;

        self.$scope = $scope;
        self.sce = $sce;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;

        self.data = SHOWSUITE.data;
        self.recs = SHOWSUITE.data.contents;
        self.category = SHOWSUITE.data.category;

        self.init();
    }

    init(){
        const self = this;

        self.apiOffset = 0;
        self.apiLimit = 10;
        self.selectedPage = 1;
        self.records = [];

        try{
            self.job_title = self.recs.title;
            if(self.recs && self.recs.title){
                if(self.recs.title.includes('&')){
                    self.job_title = self.recs.title.replace('&', '%26');
                }
            }
        }
        catch(ex){
            console.log(ex);
        }

        // Apply pagination if 'Category' is 'press'
        if(self.category == "press"){
            try{
                self.count = self.recs.length;
                self.pages = Math.ceil(self.count / self.apiLimit);
                self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
            }
            catch(ex){
                console.log(ex);
            }
            self.loadRecords();
        }
        
        self.showDetails = false;
        self.cTitle = '';
        self.cmsCode = '';
        self.cContents = false;
    }

    loadRecords(){
        const self = this;

        self.records = [];
        self.pagesArr = [];
        for (var i = 0; i < self.pages; i++) {
          self.pagesArr.push(i);
        }
        for(var j = 0; j < self.apiLimit; j++){
          if(self.apiOffset+j < self.count){
            self.records.push(self.recs[self.apiOffset + j]);
          }
        }
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.apiOffset = self.apiOffset - self.apiLimit;
        self.loadRecords();
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.apiOffset = self.apiOffset + self.apiLimit;
        self.loadRecords();
    }

    gotoPage(pageNum){
        const self = this;

        self.apiOffset = parseInt(pageNum) * self.apiLimit;
        self.loadRecords();
    }

    renderHtml(content) {
        const self = this;

        return self.sce.trustAsHtml(content);
    }

    getContents(obj) {
        let self = this;
        self.showDetails = true;

        self.cTitle = obj.title;
        self.cContents = obj.content;
        self.cmsCode = obj.code;
    }

    showPressDetail(news){
        const self = this;

        self.selectedNews = news;
        self.pressDetailView = true;
    }

    gotoPressPage(){
        const self = this;

        self.selectedNews = null;
        self.pressDetailView = false;
    }

    open(entry) {
        const self = this;

        self.entryDetails = angular.copy(entry);
        self.toggleEditContainer();
    }

    toggleEditContainer() {
        const self = this;

        self.notificationDetailsContainer = !self.notificationDetailsContainer;
        if (!self.notificationDetailsContainer) {
            angular.element('#notificationDetails').modal('hide');
        }
    }

}

PageController.$inject = ['$scope', 'SSHttpService', 'SSUtilService', 'SSAppService', '$sce'];
app.controller('PageController', PageController);

